const getRuntimeConfig = () => {
  const config = window.envConfig || {};
  config.content = window.appContent;
  return config;
};

export default getRuntimeConfig();
